export const MessageLists = {
  create_work: (obj) => `${obj.userName}から${obj.title}が配信されました。`,
  remind_work: (obj) => `${obj.userName}からのワーク${obj.title}を提出しましょう。`,
  comment_own_post: (obj) => `${obj.userName}が自分の投稿にコメントしました。`,
  comment_following_post: (obj) => `${obj.userName}も${obj.post.create_user.name}の投稿にコメントしました。`,
};
